import { soma } from "./dinheiro.js";
import { competenciaId, vencimento } from "./competencia.js";
import { calcularRedutor, descontoSimplificadoParaCompetencia, impostoPelaTabela, redutorParaCompetencia, tabelaParaCompetencia } from "./tabelas.js";
/** Codigo de receita do carne-leao (recolhimento mensal obrigatorio - PF). */
export const CODIGO_RECEITA_CARNE_LEAO = "0190";
export function apurar(entrada) {
    const avisos = [];
    const { tabela, avisos: avisosTabela } = tabelaParaCompetencia(entrada.competencia);
    avisos.push(...avisosTabela);
    // Rendimento pago por PJ sofre retencao na fonte e NAO entra no carne-leao.
    const considerados = entrada.recebimentos.filter((r) => r.pagadorTipo === "PF");
    const ignorados = entrada.recebimentos.filter((r) => r.pagadorTipo !== "PF");
    for (const r of ignorados) {
        avisos.push(`Recebimento de ${r.pagadorNome} (${r.pagadorDocumento}) ignorado: pagador e PJ, ` +
            `sujeito a retencao na fonte, fora do carne-leao.`);
    }
    for (const r of considerados) {
        if (r.dataRecebimento.ano !== entrada.competencia.ano ||
            r.dataRecebimento.mes !== entrada.competencia.mes) {
            avisos.push(`Recebimento de ${r.pagadorNome} datado de ${r.dataRecebimento.ano}-` +
                `${String(r.dataRecebimento.mes).padStart(2, "0")} lancado na competencia ` +
                `${competenciaId(entrada.competencia)}. Regime de caixa: a competencia e o mes do recebimento.`);
        }
    }
    const d = entrada.deducoes ?? {};
    const totalRecebido = soma(...considerados.map((r) => r.valorRecebido));
    // 1) Despesas do imovel sao EXCLUSOES: saem do rendimento antes de tudo.
    const despesasImovel = soma(d.iptu ?? 0, d.condominio ?? 0, d.taxaAdministracao ?? 0, d.despesasCobranca ?? 0, d.aluguelSublocacao ?? 0);
    const encargosEmTransito = entrada.encargosEmTransito ?? 0;
    const rendimentoLiquido = Math.max(0, totalRecebido - despesasImovel - encargosEmTransito);
    const deducaoDependentes = (entrada.dependentes ?? 0) * tabela.deducaoPorDependente;
    const deducaoPensao = entrada.pensaoAlimenticiaJudicial ?? 0;
    // 2) So dependentes e pensao competem com o desconto simplificado.
    const deducoesLegais = deducaoDependentes + deducaoPensao;
    const descontoSimplificado = descontoSimplificadoParaCompetencia(entrada.competencia);
    const usouDescontoSimplificado = descontoSimplificado > deducoesLegais;
    const deducaoAplicada = Math.max(deducoesLegais, descontoSimplificado);
    const baseCalculo = Math.max(0, rendimentoLiquido - deducaoAplicada);
    if (despesasImovel > totalRecebido) {
        avisos.push("Despesas do imovel superaram o aluguel recebido no mes. Rendimento zerado.");
    }
    if (deducaoAplicada > rendimentoLiquido && rendimentoLiquido > 0) {
        avisos.push("Deducoes superaram o rendimento do mes. Base zerada — nao ha compensacao " +
            "de excedente para o mes seguinte no carne-leao de aluguel.");
    }
    const impostoTabela = impostoPelaTabela(baseCalculo, tabela);
    // Redutor da Lei 15.270/2025, aplicado sobre o imposto ja apurado.
    // Redutor sobre o rendimento LIQUIDO — confirmado no Carne-Leao Web:
    // aluguel 8.000 com despesa 1.500 (liquido 6.500) deu R$ 598,61, ou seja,
    // COM redutor, embora o bruto de 8.000 estivesse fora da faixa.
    const regraRedutor = redutorParaCompetencia(entrada.competencia);
    const redutor = regraRedutor
        ? calcularRedutor(rendimentoLiquido, regraRedutor, impostoTabela)
        : 0;
    const imposto = Math.max(0, impostoTabela - redutor);
    if (redutor > 0 && imposto === 0) {
        avisos.push("Imposto zerado pelo redutor da Lei 15.270/2025. O DARF nao precisa ser " +
            "emitido, mas o rendimento continua a ser declarado no IRPF do ano seguinte.");
    }
    return {
        competencia: entrada.competencia,
        competenciaId: competenciaId(entrada.competencia),
        vencimento: vencimento(entrada.competencia),
        codigoReceita: CODIGO_RECEITA_CARNE_LEAO,
        totalRecebido,
        despesasImovel,
        ...(despesasImovel > 0 ? { despesasDetalhe: d } : {}),
        ...(encargosEmTransito > 0 ? { encargosEmTransito } : {}),
        rendimentoLiquido,
        deducaoDependentes,
        deducaoPensao,
        deducaoAplicada,
        usouDescontoSimplificado,
        baseCalculo,
        impostoTabela,
        redutor,
        imposto,
        recebimentosConsiderados: considerados,
        recebimentosIgnorados: ignorados,
        tabelaAplicada: tabela.vigenciaInicio,
        avisos,
    };
}
//# sourceMappingURL=apuracao.js.map